module.exports = __webpack_public_path__ + "static/img/337.157d49d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200513/337.jpg
// module id = Xb4H
// module chunks = 0